import {useMutation} from '@apollo/client'
import React, {useEffect} from 'react'
import {Alert, Button, Modal, Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import {IResDeleteStage} from '../../../types/pipelines'
import {DELETE_STAGE_PIPELINE} from '../../../gql/mutations/pipelineMutations'

interface IModalDeleteStage {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  infoEdit: {id: string; name: string}
}

export const ModalDeleteStage: React.FC<IModalDeleteStage> = ({
  isOpen,
  onClose,
  refetch,
  infoEdit,
}) => {
  const [gqlAddEditStage, {data, loading, error}] =
    useMutation<IResDeleteStage>(DELETE_STAGE_PIPELINE)

  useEffect(() => {
    if (error) toast.error('Error: ' + error.message)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.deleteStageMutation.success) {
      toast.success(`Success: Stage successfully removed`)
      onClose()
      refetch()
    } else if (data.deleteStageMutation?.errors?.length > 0) {
      toast.error(
        `Error: ${data.deleteStageMutation?.errors?.[0]?.message || 'Something happened'}`
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDelete = () => {
    gqlAddEditStage({
      variables: {
        stageId: parseId(infoEdit.id),
      },
    })
  }
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Stage</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h2 className='text-danger pb-5'>
          Are you sure you want to delete this stage{' '}
          <span className='text-primary'>"{infoEdit.name}"</span>?
        </h2>
        <Alert variant='warning' className='mt-6 d-flex align-items-center gap-3'>
          <i className='bi bi-exclamation-triangle fs-1' style={{color: 'inherit'}} /> This stage
          will be eliminated if there is no associated lead
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button type='button' variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant='danger'
          className='d-flex align-items-center'
          disabled={loading}
          onClick={handleDelete}
        >
          {loading && <Spinner animation='border' size='sm' />}
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
